import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TabActionPatient } from "../../../../../actions/PatientActions";
import { TabActionReports } from '../../../../../actions/ReportActions/ReportActions';
import { TabActionClaims } from '../../../../../actions/BillingActions';
import { TabActionPayments } from '../../../../../actions/BillingActions';
import { MainTabContentActiveTab, MainTabContentTabList } from "../../../../../actions/SidebarAction";
import { convertTimeToHMS } from '../../../../../utils/Constants';
import useHandleOpenNewBrowserTab from '../../../../shared/NewTabBrowser/useHandleOpenNewBrowserTab';
import { NoHistoryIcon } from '../../../../shared/IconsComponent/icons';
// import MenuItemsList from '../../../Menu';
const History = () => {
    // const menuItems = MenuItemsList();
    let iconObj = {
        "Dashboard": 'bi bi-grid-fill',
        "Billing Items": 'icon-BILLING',
        "Task": 'icon-TASK',
        "Messages": 'bi bi-chat-dots-fill',
        "Scheduler": 'icon-SCHEDULER',
        "Patient": 'icon-PATIENTT',
        "Caregiver": 'icon-caregiver-1',
        "Claims": 'bi bi-clipboard2-minus-fill',
        "Submission": 'bi bi-file-earmark-check-fill',
        "Payments": 'bi bi-currency-dollar',
        "Realtime": 'icon-REALTIME',
        "Account Receivables": 'bi bi-file-earmark-medical-fill',
        "Statements": 'icon-STATEMENTS',
        "Document": 'icon-DOCUMENTS',
        "Reports": 'icon-REPORTS',
        "Setup": 'icon-SETUP',
        "Data Import": 'icon-DATA-IMPORT',
        "Monitoring": 'icon-MONITORING',
        "Support": 'icon-SUPPORT',
        "My Profile": 'bi bi-person-fill',
        "Switch Practice": 'bi bi-arrow-left-right',
    }
    let state = useSelector(state => state.SidebarList)
    let stateRedux = useSelector(state => state)
    const dispatch = useDispatch();
    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
    const [show, setShow] = useState(false);
    const [searchValue, setSearchValue] = useState()
    const [arr, setArr] = useState([])
    const [isClearedTime, setIsClearedTime] = useState();

    const handleSearch = (e) => {
        setSearchValue(e.target.value)
    }
    ///////////Handle Open Tab//////////
    const handleOpenTab = (item) => {
        item.data ? handleOpenSubTab(item) : handleOpenMainTab(item.key);
    }
    ///////////Handle Open Main Tab//////////
    const handleOpenMainTab = (key) => {
        const isTabExist = [...stateRedux.SidebarList].filter((tab) => {
            if (tab.key === key) {
                tab.time = new Date()
                return tab
            }
            return tab
        })
        dispatch(MainTabContentActiveTab(key))
        dispatch(MainTabContentTabList(isTabExist));
    }
    ///////////Handle Open Sub Tab//////////
    const handleOpenSubTab = (data) => {
        let dataProp = {
            id: data.data.id,
            name: data.data.name,
            time: new Date(),
        };
        let objPatient = {
            key: 2,
            name: "Patient",
            active: true,
            data: dataProp,
        };
        let objClaim = {
            key: 2,
            name: "Claims",
            active: true,
            data: dataProp,
        };
        let objPayment = {
            key: 2,
            name: "Payments",
            active: true,
            data: dataProp,
        };
        let objReport = {
            key: 2,
            name: "Reports",
            active: true,
            data: dataProp,
        };
        switch (data.name) {
            case "Patient":
                dispatch(MainTabContentActiveTab(2))
                dispatch(TabActionPatient(objPatient))
                break;
            case "Claims":
                dispatch(MainTabContentActiveTab(71))
                dispatch(TabActionClaims(objClaim))
                break;
            case "Payments":
                dispatch(MainTabContentActiveTab(73))
                dispatch(TabActionPayments(objPayment))
                break;
            case "Reports":
                dispatch(MainTabContentActiveTab(4))
                dispatch(TabActionReports(objReport))
                break;
            default:
                // Code block to execute when none of the cases match expression
                break;
        }
    }
    ///////////Create History Array/////////
    const handleCreateHistoryArray = (historyArr, reduxData, name) => {
        if (historyArr.length === 0) {
            for (let j in reduxData) {
                if (reduxData[j].name === name) {
                    historyArr.push(reduxData[j]);
                }
            }
        } else {
            for (let i in historyArr) {
                for (let j in reduxData) {
                    if (reduxData[j].name === name) {
                        if (historyArr[i].id && reduxData[j].data.id === historyArr[i].id) {
                            historyArr[i] = reduxData[j];
                        } else if (!historyArr[i].id) {
                            historyArr.push(reduxData[j]);
                        }
                    }
                }
            }
        }
        return historyArr;
    };
    //////Merging Data from Redux For Tabs History/////
    const handleTabsHistory = () => {
        let historyArr = []
        ///////////SideBar_Tab///////////////
        historyArr = [...state]
        ///////////Open_Patient_Tab///////////////
        historyArr = handleCreateHistoryArray(historyArr, stateRedux.Open_Patient_Tab, "Patient")
        ////////////Open_Report_Tab//////////////
        historyArr = handleCreateHistoryArray(historyArr, stateRedux.Open_Report_Tab, "Reports")
        ////////////Open_Claim_Tab//////////////
        historyArr = handleCreateHistoryArray(historyArr, stateRedux.Open_Claim_Tab, "Claims")
        ////////////Open_Payment_Tab//////////////
        historyArr = handleCreateHistoryArray(historyArr, stateRedux.Open_Payment_Tab, "Payments")
        ///////////REMOVING DUPLICATES AND SORTING ON BASIS OF TIME//////////////////
        historyArr = Array.from(new Set(historyArr)).sort((a, b) => {
            let A = a.data ? a.data.time : a.time;
            let B = b.data ? b.data.time : b.time;
            return B - A
        })
        if (searchValue) {
            const lowerSearch = searchValue.toLowerCase();
            historyArr = historyArr.filter(item =>
                item.name.toLowerCase().includes(lowerSearch)
            );
        }

        if (isClearedTime) {
            const clearedTime = isClearedTime.getTime();
            historyArr = historyArr.filter(item =>
                getItemTime(item) > clearedTime
            );
        }

        setArr([...historyArr]);
    }
    const handleCloseMainTab = (key) => {
        const isTabExist = [...stateRedux.SidebarList].filter((tab) => {
            if (tab.key === key) { }
            else return tab;
        })
        isTabExist && dispatch(MainTabContentTabList(isTabExist));
    }
    const handleCloseSubTab = (item) => {
        switch (item.name) {
            case "Patient":
                dispatch(TabActionPatient({}, item.data.id))
                break;
            case "Claims":
                dispatch(TabActionClaims({}, item.data.id))
                break;
            case "Payments":
                dispatch(TabActionPayments({}, item.data.id))
                break;
            case "Reports":
                dispatch(TabActionReports({}, item.data.id))
                break;
            default:
                // Code block to execute when none of the cases match expression
                break;
        }
    }
    const closeTab = (item) => {
        if (item && item.data) { handleCloseSubTab(item) }
        else { item && handleCloseMainTab(item.key) }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            const elementsToCheck = ['.icon-Icon-material-timelapse', '.hr-header', '.hr-search', '.ar-footer', '.ar-content', '.clear_all'];
            const isClickInsideTab = elementsToCheck.some(selector => {
                const element = document.querySelector(selector);
                return element && element.contains(event.target);
            });
            if (!isClickInsideTab) {
                setShow(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [stateRedux.Login])

    useEffect(() => {
        handleTabsHistory()
    }, [stateRedux, searchValue])

    // const getIcon = (compName) => {
    //     return menuItems?.find(item => {
    //         if(item.name === compName){
    //             return item
    //         } else{
    //             return item?.subComponents?.find(items =>
    //                 items.name === compName
    //             )
    //         }
    //     })?.icon;
    // }
    const handleClearAll = (e) => {
        e.stopPropagation();
        setArr([])
        setIsClearedTime(new Date())
    }

    const getItemTime = item => new Date(item.data?.time ?? item.time);

    const lowerSearch = searchValue?.toLowerCase();
    const clearedTime = isClearedTime?.getTime();

    const historyExist = Array.isArray(arr) && arr.some(item => {
        const matchesSearch = lowerSearch ? item.name.toLowerCase().includes(lowerSearch) : true;
        const isAfterCleared = clearedTime ? getItemTime(item) > clearedTime : true;
        return matchesSearch && isAfterCleared;
    });
    return (
        <>
            <div className="alert-icon session-btn app_tooltip bottom" onClick={() => setShow(!show)}>
                <i className="icon-Icon-material-timelapse mt-1"></i>
                <p class="tool_tip xsm_text text-light">History</p>
            </div>
            <div className={`hk-CurSession__Tab ar-CurSession__Tab  ${show && 'active-Tab'}`}>

                <div className="d-flex justify-content-between align-items-center mb-10 px-10 hr-header pt-15">
                    <p className="heading">History</p>
                    {/* <p className="heading fs-10 link cursor-pointer">VIEW ALL</p> */}
                </div>
                {historyExist &&
                <div className="px-10 mb-10 hr-search">
                    <div className="ar-input  position-relative">
                        <input type="text" className="form-control fc-xs" placeholder="Search...."
                            value={searchValue}
                            onChange={handleSearch}
                        />
                        <i className='icon-Clip-path-group'></i>
                    </div>
                </div>}
                <div className="scroll px-10 mb-10 d-flex flex-column gap-10">

                    {arr && arr?.map((item, key) => {
                        let formattedTime = convertTimeToHMS(item.data ? item.data.time : item.time);
                        let isCleared = (isClearedTime?.getTime() >= getItemTime(item));
                        if (isCleared) return;
                        return (
                            <>

                                <div className="ar-content" key={key}>
                                    <div className='ar-header d-flex justify-content-between align-items-center'>
                                        <div className="d-flex align-items-center gap-2 pb-1 cursor-pointer" onClick={() =>
                                            handleOpenTab(item)}>
                                            <i className={`${iconObj[item?.name]} icon-dark-color fs-12`}></i>
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="text fs-11 font-m text-nowrap validation_message"> {item.data ? <>{item.name}</> : ''} {item.data ?
                                                    <>{item.name === 'Payments' ? '' : item.data.id}-{item.data.name}</> : <>{item.name}</>}
                                                </p>
                                                {item.data &&
                                                    <i className="icon-icon-arrow-top-right fs-10" onClick={(e) => { handleOpenNewBrowserTab(item); e.stopPropagation(); }}></i>}
                                            </div>

                                        </div>
                                        <i className="fs-10 icon-Icon-metro-cross opacity-0" onClick={() => closeTab(item)}></i>
                                    </div>
                                    {/* {item.data &&
                                        <button className="btn-icon-transparent" onClick={() => handleOpenNewBrowserTab(item)}>
                                            <i className="bi bi-back me-1" ></i>
                                        </button>} */}
                                    {/* <button className="btn-icon-transparent" onClick={() => closeTab(item)}>
                                        <i className="icon-Icon-metro-cross" ></i>
                                    </button> */}
                                    <p className="text ar-light-color fs-10 fst-italic">{formattedTime} </p>
                                </div>
                            </>
                        )
                    })}
                    {historyExist ? <></> :
                        <div className="d-flex align-items-center justify-content-center flex-column gap-12 py-3 my-1">
                            <NoHistoryIcon classes={'fs-48'} />
                            <div className="text-center">
                                <p className='text fs-12 font-m'>No History!</p>
                                <p className='text fs-11 ar-ligh-color'>We’ll show your recent activity here.</p>
                            </div>
                        </div>
                    }
                </div>

                {historyExist ?
                    <div className="px-10 d-flex align-items-center justify-content-end ar-footer pb-15">
                        <div className='d-flex align-items-center gap-1 clear_all' onClick={handleClearAll}>
                            <i className="icon-Icon-metro-cross fs-8"></i>
                            <p className="text fs-11 cursor-pointer">Clear All</p>
                        </div>
                    </div>
                    : null}

            </div>
        </>
    )
}

export default History